import createErrors from '../createErrors';
import { type Page } from './constants';

export type Component = 'SignInForm' | 'Auth0CartMerge';

/**
 * Errors related to the Create Account page
 */
export const Errors = createErrors<Page, Component>('SignIn')({
    SignInForm: {
        SubmitFailed: {
            severity: 'HIGH',
            message: 'Failed to submit the sign in form',
        },
        ValidateCartMerge: {
            severity: 'HIGH',
            message: 'Failed to validate cart merge',
        },
    },
    Auth0CartMerge: {
        MergeFailed: {
            severity: 'HIGH',
            message: 'Failed to merge guest cart after Auth0 authentication',
        },
    },
});
